export const DATE_FORMATS = {
  order: "EEE, MMMM d, yyyy h:mm aa",
  orderCheckout: "ddd MMM DD, YYYY",
  viewOrderDate: "ddd MM-DD-YY",
  deliveryTime: "hh:mm A",
  year: "YYYY",
  catererDate: 'MM/DD/YYYY',
  humanReadableDate: "dddd, MMMM D, YYYY",
  humanReadableTime: "h:mm A"
};
